import { TypedEventEmitter } from '@/utils/TypedEventEmitter';

// The editor's single change signal, carrying no payload: consumers re-read the
// state they care about. Composes the shared emitter instead of exposing it, so
// call sites stay emit() rather than repeating a 'change' literal two dozen
// times. Node's wider surface is one delegating method away if ever needed.
class ChangeEmitter {
    private readonly _events = new TypedEventEmitter<{ change: undefined }>();

    subscribe(callback: () => void): () => void {
        return this._events.subscribe('change', callback);
    }

    emit(): void {
        this._events.emit('change');
    }
}

export { ChangeEmitter };
